<template>
  <div class="Filters">
    <template v-for="filter in beforeSplitter" :key="filter.id">
      <slot
        name="default"
        v-bind="{
          filter,
          selectedFilter: filtersStorage.tags.hasTag(filter.id),
          addOrRemoveTag: tag => {
            filtersStorage.tags.tagList = tag
          }
        }"
      />
    </template>
    <slot name="splitter" />
    <template v-for="filter in afterSplitter" :key="filter.id">
      <slot
        name="default"
        v-bind="{
          filter,
          selectedFilter: filtersStorage.tags.hasTag(filter.id),
          addOrRemoveTag: tag => {
            filtersStorage.tags.tagList = tag
          }
        }"
      />
    </template>
  </div>
</template>

<script>
import useAmbiFilter from './AmbiFilter'

/*
const shuffleFilter = {
  id: 'shuffle',
  name: 'Náhoda',
  bg_color: '#C8102E',
  text_color: '#fff'
}
*/

export default {
  props: {
    filters: Array
  },
  setup() {
    const { selectedFilters, setFilter, scrollToAnchor, filtersStorage } = useAmbiFilter()

    return {
      selectedFilters,
      setFilter,
      scrollToAnchor,
      filtersStorage
    }
  },
  computed: {
    beforeSplitter() {
      return this.filters.filter(filter => filter.show_after_splitter == 0)
    },
    afterSplitter() {
      //return [...this.filters.filter(filter => filter.show_after_splitter == 1), shuffleFilter]
      return this.filters.filter(filter => filter.show_after_splitter == 1)
    }
  },
  mounted() {
    // TODO: maybe later
    // read & load filters from URL ...
    /*
    let url = location.hash
    const filterMask = '#f='

    if (url.startsWith(filterMask)) {
      url = url.replace(filterMask, '')
      let filtersIds = url.split('.')

      if (filtersIds.length) {
        this.loadFilters(filtersIds)
        setTimeout(() => {
          this.scrollToAnchor()
        }, 300)
      }
    }*/
  }
}
</script>
